import { createTheme } from '@mui/material/styles';

export const ResourceAutoCompleteTheme = createTheme({
  components: {
    MuiAutocomplete: {
      styleOverrides: {
        option: {
          '&[aria-selected="true"]': {
            backgroundColor: '#FDBC6033 !important',
            '&:hover': {
              backgroundColor: '#e6e9ee !important',
            },
          },
          '&:hover': {
            backgroundColor: '#e6e9ee !important',
          },
        },
        paper: {
          boxShadow: 'none !important',
        },
        listbox: {
          maxHeight: '200px',
          '&::-webkit-scrollbar-thumb': {
            background: '#bdbdbd !important',
            borderRadius: '6px !important',
          },
          '&::-webkit-scrollbar': {
            width: '7px',
            background: '#f5f5f5',
            borderRadius: '6px',
          },
        },
      },
    },
  },
});
